import { useState } from 'react'

import { faBars, faCaretLeft, faCaretRight } from '@fortawesome/pro-solid-svg-icons'

import IconButton from '../antd/Buttons/IconButton'
import { isFunction } from 'lodash'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const Expandable = ({ children, className, defaultExpanded = true, onExpandChange }) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded)
  const [isHovered, setIsHovered] = useState(false)

  const style = isExpanded ? { borderRight: '1px solid #d9d9d9' } : { }

  const handleToggle = () => {
    const newExpanded = !isExpanded

    setIsExpanded(newExpanded)
    if (isFunction(onExpandChange)) {
      onExpandChange(newExpanded)
    }
  }

  return (
    <div className='flex-row h-100 settings' style={{ position: 'relative' }}>
      <div className='btn-small pd-4' style={style}>
        <IconButton icon={faBars} onClick={handleToggle} />
      </div>

      {isExpanded && (
        <div className='h-100 pd-8' style={{ width: 'calc(100% - 38px)' }}>
          {children}
        </div>
      )}
      <div
        className='cu-ptr'
        style={{
          height: '80px',
          width: '14px',
          border: `2px solid ${isHovered ? '#3c8dbc' : '#A9A9A9'}`,
          borderRadius: '10px',
          position: 'absolute',
          top: '50%',
          right: '-7px',
          backgroundColor: '#fff',
          transform: 'translateY(-50%)',
          transition: 'border-color 0.2s ease'
        }}
        onClick={handleToggle}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <FontAwesomeIcon
          icon={isExpanded ? faCaretLeft : faCaretRight}
          style={{
            color: isHovered ? '#3c8dbc' : 'grey',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            transition: 'color 0.2s ease'
          }}
        />
      </div>
    </div>
  )
}

export default Expandable
